/** @format */

import { Component, inject, input } from '@angular/core';

import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { AnalyticsService, UtilityService } from '@shared/data-access/services';

@Component({
	selector: 'pdp-component-stylitics-jumplink',
	imports: [HmfButtonComponent],
	templateUrl: './stylitics-jumplink.component.html',
	styleUrl: './stylitics-jumplink.component.scss'
})
export class StyliticsJumplinkComponent {
	private readonly utilityService = inject(UtilityService);
	private readonly analyticsService = inject(AnalyticsService);

	readonly isMobile = input(true);
	readonly disabled = input(false);

	handleClick() {
		const stylitics = document.querySelector<HTMLElement>('pdp-component-stylitics');
		this.utilityService.scrollToElement(stylitics);
		this.analyticsService.triggerAnalyticsEvent('multiUseAnalyticsEvent', {
			event: 'pdp_styliticsJumpLink'
		});
	}
}
